import { Injectable } from '@angular/core';
import { CanLoad, Router, UrlTree } from '@angular/router';
import { UserPermissionsService } from '@cpak/main-features-lib/services';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MasterTemplateGuard implements CanLoad {
  public constructor(private readonly userPermissions: UserPermissionsService, private readonly router: Router) {}

  public canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userPermissions
      .hasMasterTemplateManagePermission()
      .pipe(map(hasPermission => hasPermission || this.router.createUrlTree(['/'])));
  }
}
